module.exports = __webpack_public_path__ + "img/CNA2.5e6f1988.jpg";